import React from 'react';
import { PropTypes } from 'prop-types';

const trailerTypes = ['trailer', 'tractor_unit'];

const Vehicles = ({ className, vehicles, t }) => {
  const renderLabel = () => {
    if (!(vehicles || []).length) {
      return t('label.assigned_vehicles.no_vehicle');
    }
    const justOneVehicle = vehicles.length === 1;
    const hasTrailerVehicle = vehicles.some(({ vehicle_type }) =>
      trailerTypes.includes(vehicle_type?.slug)
    );
    const vehicleIsMissing = justOneVehicle && hasTrailerVehicle;
    if (!vehicleIsMissing) {
      return vehicles.map(({ plate_number }) => plate_number).join(' + ');
    }
    const firstVehicle = vehicles[0];
    const { plate_number, vehicle_type } = firstVehicle;
    const isTrailer = vehicle_type?.slug === 'trailer';
    return isTrailer
      ? `${plate_number} + ${t('label.assigned_vehicles.missing_head')}`
      : `${plate_number} + ${t('label.assigned_vehicles.missing_trailer')}`;
  };

  const label = renderLabel();

  return (
    <div className={className}>
      <span title={label}>{label}</span>
    </div>
  );
};

Vehicles.propTypes = {
  className: PropTypes.string,
  vehicles: PropTypes.array,
  t: PropTypes.func,
};

Vehicles.defaultProps = {
  className: '',
  vehicles: [],
  t: (t) => t,
};
export default Vehicles;
